import { useState } from "react";
import { languages } from "../language/languages";

const useLanguage = (locale) => {
    const [language, setLanguage] = useState(languages.schema[locale]);

    const toggler = (name) => {
        setLanguage(languages.schema[name]);
    };

    // useEffect(() => {
    //     setLanguage(languages.schema[locale]);
    // }, [language]);

    return [language, toggler];
};

export default useLanguage;